import React from 'react';
import { Layout } from 'antd';
import './BasicLayout.less';
const { Footer } = Layout

export default ({ children }) => 
<div className="content-basic">{children}
    {/* <Footer className="footer">&copy; 2020 PT. Dharma Polimetal ERP</Footer> */}
</div>;